<main class="main-container" [class.main-container__track-feedback]="isTrackRatingMode">
  <div class="close-icon" [class.close-icon__track-feedback]="isTrackRatingMode">
    <i nz-icon nzType="close" nzTheme="outline" (click)="closeModal()"></i>
  </div>

  <h2 class="modal-title" [class.modal-title__track-feedback]="isTrackRatingMode">{{ modalTitle }}</h2>

  <form
    (ngSubmit)="sendRating()"
    autocomplete="off"
    class="feedback-form"
    [class.feedback-form__track-feedback]="isTrackRatingMode">
    <ng-container *ngIf="isTrackRatingMode">
      <p class="track-feedback-title"><b>Parabéns por concluir a trilha!</b></p>
      <p class="track-feedback-description">
        Seu feedback nos ajuda a melhorar. Como você avalia sua experiência?
      </p>
    </ng-container>

    <section class="stars-section" [class.stars-section__track-feedback]="isTrackRatingMode">
      <h4>{{ ratingSectionTitle }}</h4>

      <div class="subject-stars">
        <div class="subject-stars--list">
          <ng-container *ngIf="isTrackRatingMode; else courseRatingTemplate">
            <nz-rate
              [(ngModel)]="ratingPayload.score"
              [nzCharacter]="trackStar"
              [ngModelOptions]="{ standalone: true }"
            ></nz-rate>
          </ng-container>

          <ng-template #courseRatingTemplate>
            <nz-rate
              [(ngModel)]="ratingPayload.score"
              [nzCharacter]="star"
              [ngModelOptions]="{ standalone: true }"
            ></nz-rate>
          </ng-template>

          <ng-template #star>
            <i class="stars" nz-icon nzType="star" nzTheme="twotone"></i>
          </ng-template>

          <ng-template #trackStar>
            <span class="track-star-char">&#9733;</span>
          </ng-template>
        </div>
      </div>

      <div class="textarea-wrapper">
        <textarea
          [(ngModel)]="ratingPayload.comment"
          [ngModelOptions]="{ standalone: true }"
          name="comment"
          (ngModelChange)="valueChange()"
          maxlength="450"
          [placeholder]="commentPlaceholder"
        ></textarea>

        <span *ngIf="!isTrackRatingMode" class="remaning">{{ characterCounter }}/450</span>
      </div>
    </section>

    <section class="footer" [class.footer__track-feedback]="isTrackRatingMode">
      <ng-container *ngIf="didUserTriedToSendScoreZero">
        <p class="score-required-warning">Atenção! O mínimo de estrelas para avaliar é 1!</p>
      </ng-container>

      <button type="submit" class="uni--primary-button submit-button" nz-button [nzLoading]="isSendingRating">
        {{ isSendingRating ? '' : submitButtonText }}
      </button>
    </section>
  </form>
</main>
